import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { uploadImagecertifates } from "../../../Redux/Actions/Action";
import axios from "axios";
import toast from "react-hot-toast";
import { IoIosCloseCircle } from "react-icons/io";

function CategoryEditC() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (id) {
      const fetchCategoryData = async () => {
        try {
          setFetching(true);
          const token = localStorage.getItem("vedhvidhi-admin-token");
          const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/admin/category/${id}`,
            { headers: { Authorization: token } }
          );
          
          if (response.data?.data) {
            const categoryData = response.data.data;
            reset({
              categoryName: categoryData.categoryName || "",
              description: categoryData.description || "",
              categoryIcon: categoryData.categoryIcon || "",
            });
            if (categoryData.categoryIcon) {
              setImage(categoryData.categoryIcon);
            }
          }
        } catch (error) {
          console.error("Error fetching category:", error);
          toast.error("Failed to fetch category data");
        } finally {
          setFetching(false);
        }
      };
      fetchCategoryData();
    }
  }, [id, reset]);

  // Handle image upload
  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.match(/image\/(jpg|jpeg|png|webp|gif)/i)) {
      toast.error("Please upload a valid image file (JPG, PNG, WEBP, GIF)");
      return;
    }

    setLoading(true);
    try {
      const uploadedImageUrl = await dispatch(uploadImagecertifates(file));
      setImage(uploadedImageUrl);
      setValue("categoryIcon", uploadedImageUrl);
      toast.success("Image uploaded successfully!");
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Failed to upload image");
    }
    setLoading(false);
  };

  // Remove uploaded image
  const handleRemoveImage = () => {
    setImage(null);
    setValue("categoryIcon", "");
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("vedhvidhi-admin-token");
      const payload = {
        categoryName: data.categoryName,
        description: data.description || "",
        categoryIcon: data.categoryIcon || "",
      };
      
      const response = await axios.patch(
        `${process.env.REACT_APP_BASEURL}/admin/category/${id}`,
        payload,
        { headers: { Authorization: token } }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("Category updated successfully!");
        navigate("/category-management");
      }
    } catch (error) {
      console.error("Error updating category:", error);
      toast.error(error.response?.data?.message || "Failed to update category.");
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return (
      <div className="card-body">
        <div className="text-center py-5">
          <p>Loading category data...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="card-body">
        <form className="row" onSubmit={handleSubmit(onSubmit)}>
          <div className="col-sm-6">
            <div className="form-group text-start">
              <label className="form-label">Category Name</label>
              <input
                className="form-control"
                type="text"
                placeholder="Enter category name"
                {...register("categoryName", {
                  required: "Category name is required",
                })}
              />
              {errors.categoryName && (
                <p className="text-danger">{errors.categoryName.message}</p>
              )}
            </div>
          </div>

          {/* Image Upload Field */}
          <div className="col-sm-6">
            <div className="form-group text-start">
              <label className="form-label">Category Image</label>
              <input
                type="file"
                accept=".jpg,.jpeg,.png,.webp,.gif"
                className="form-control"
                onChange={handleImageUpload}
                disabled={loading}
              />
              {loading && (
                <small className="text-muted d-block mt-2">Uploading...</small>
              )}
              <div className="mt-3">
                {image ? (
                  <div className="position-relative d-inline-block">
                    <img
                      src={image}
                      alt="uploaded"
                      style={{
                        width: "200px",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "10px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <button
                      type="button"
                      className="btn btn-sm bg-transparent border-0 position-absolute top-0 end-0"
                      onClick={handleRemoveImage}
                      style={{ padding: "0" }}
                    >
                      <IoIosCloseCircle size={26} color="#727070" />
                    </button>
                  </div>
                ) : (
                  <div
                    style={{
                      width: "200px",
                      height: "150px",
                      border: "2px dashed #ccc",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#999",
                    }}
                  >
                    No image selected
                  </div>
                )}
              </div>
              <input
                type="hidden"
                {...register("categoryIcon")}
              />
            </div>
          </div>

          {/* Textarea Field */}
          <div className="col-12">
            <div className="form-group text-start">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                rows="4"
                placeholder="Enter category description"
                {...register("description")}
              />
            </div>
          </div>

          <div className="col-12 mt-4">
            <button 
              type="submit" 
              className="btn btn-primary text-uppercase px-5"
              disabled={loading}
            >
              {loading ? "SAVING..." : "SAVE"}
            </button>
            <Link
              to="/category-management"
              className="btn btn-primary text-uppercase px-5 mx-2"
            >
              CANCEL
            </Link>
          </div>
        </form>
      </div>
    </>
  );
}

export default CategoryEditC;